/*
 *
 * TechnicalErrorModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 07-Nov-2024
*/

import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import AnimationIcon from '@nexidigital/animationicon'
import { AnalyticsContext } from 'Hoc/AnalyticsProvider'
import './TechnicalErrorModal.scss'

const TechnicalErrorModal = props => {
  const analyticsContext = useContext(AnalyticsContext)
  const { setPopupClickAnalytics } = analyticsContext || {}

  useEffect(() => {
    setPopupClickAnalytics && setPopupClickAnalytics(
      formattedMessage.title,
      null,
      formattedMessage.buttonLabel,
      null,
      'close',
      false
    )
  }, [])

  const handleCloseAction = (actionLabel) => {
    props.actions.doHidePopup()
    setPopupClickAnalytics && setPopupClickAnalytics(
      formattedMessage.title,
      null,
      formattedMessage.buttonLabel,
      null,
      'close',
      actionLabel
    )
  }

  return (
    <Toggle>
      <MerchantModal
        iconName='errorCheck'
        onClose={() => handleCloseAction('close')}
        primaryAction={() => handleCloseAction(formattedMessage.buttonLabel)}
        primaryButtonLabel={formattedMessage.buttonLabel}
        disableSendAnalytics
      >
        <div className='errorModal'>
          <div className='errorModalIcon'>
            <AnimationIcon status='error' size='large' loop={false} />
          </div>
          <div className='errorModalTitle'>
            {formattedMessage.title}
          </div>
        </div>
      </MerchantModal>
    </Toggle>
  )
}

TechnicalErrorModal.propTypes = {
  actions: PropTypes.object.isRequired
}

TechnicalErrorModal.defaultProps = {
  actions: {}
}

export default TechnicalErrorModal
